import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6976ef121beda800149d62b7/cosmeticstore/src/app/product-catalog/components/ProductCatalogInteractive.tsx");
